export const VALID = "#32936F";
export const PRIMARY_LIGHT = "#f39c1a";
export const TEXT_COLOR_DISABLED = "#a09e9e";
export const INVALID = "#E84B58";
export const TRANSPARENT = "#00000000"
export const BLUE = "#191E27"